import { render, staticRenderFns } from "./BookMainPrint.html?vue&type=template&id=70f40183&scoped=true&"
import script from "./BookMainPrint.ts?vue&type=script&lang=ts&"
export * from "./BookMainPrint.ts?vue&type=script&lang=ts&"
import style0 from "./BookMainPrint.scss?vue&type=style&index=0&id=70f40183&scoped=true&lang=scss&"
import style1 from "./BookMainPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f40183",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
